import './styles.css'
import React from 'react'
import { Label, TextArea } from 'semantic-ui-react'

export default function BookingDetailsTextarea(props) {
  const { value, onChange, id, classes, placeholder, maxLength = 150, isDisabled } = props

  return (
    <>
      <TextArea
        id={id}
        placeholder={placeholder || ''}
        value={value}
        onChange={onChange}
        className={classes}
        style={{ resize: 'none' }}
        disabled={isDisabled}
        maxLength={maxLength}
      />

      <div className="textarea-footer">
        <Label basic size="small">
          {value.length}/{maxLength}
        </Label>
      </div>
    </>
  )
}
